import { ComponentIds, HierarchyUtils, MathUtils, Transform, TransformUtils, Vector } from '@inter-ikea-core/core';
import AnimateHingeDoorsComponent from '../components/AnimateHingeDoorsComponent';
import AnimationCallbackComponent from '../components/AnimationCallbackComponent';
import AnimationComponent from '../components/AnimationComponent';
import SeeThroughFrontComponent from '../components/SeeThroughFrontComponent';
import { PlannerEcsMultiSystem } from './System';
export class AnimateHingeDoorsSystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'AnimateHingeDoorsSystem', [
            AnimateHingeDoorsComponent.id,
            AnimationCallbackComponent.id,
            SeeThroughFrontComponent.id
        ]);
    }
    onAdd(entity, newComponent) {
        if (newComponent.typeId === AnimateHingeDoorsComponent.id) {
            this.animateEntity(entity, newComponent);
        }
    }
    onUpdate() { }
    onRemove(entity, oldComponent) {
        if (oldComponent.typeId === AnimationCallbackComponent.id) {
            this.toggleDoors();
            const door = entity.getComponent(ComponentIds.CHILD_COMPONENT_ID)?.parent;
            door?.removeComponent(AnimateHingeDoorsComponent.id);
        }
        else if (oldComponent.typeId === SeeThroughFrontComponent.id) {
            const hideDoors = entity.getComponent(AnimateHingeDoorsComponent.id)?.hideDoors;
            const door = HierarchyUtils.findWithComponentInUpwardsHierarchy(entity, ComponentIds.DOOR_COMPONENT_ID);
            if (door) {
                this.coreApi.entities.setAllVisible([door], !!hideDoors, true);
            }
        }
    }
    /**
     * To avoid doors colliding, we move the doors slightly
     * along the X axis
     */
    getXOffset(from, to) {
        if (Math.abs(from.Y) > Math.abs(to.Y)) {
            return 8;
        }
        else if (Math.abs(from.Y) < Math.abs(to.Y)) {
            return -8;
        }
        else {
            return 0;
        }
    }
    animateEntity(entity, component) {
        if (!component.hideDoors) {
            this.toggleDoors(false);
        }
        const pivot = this.getPivot(entity);
        if (!pivot) {
            return;
        }
        const transform = TransformUtils.localTransform(pivot);
        if (transform) {
            const initialRotation = transform.rotation.toEulerDegrees();
            const isFlipped = transform.rotation.toEulerDegrees().Z === 180;
            const sign = isFlipped ? -1 : 1;
            const endRotation = MathUtils.quaternionFromEulerDegrees(new Vector(initialRotation.X, sign * component.angle, initialRotation.Z));
            const xOffset = this.getXOffset(endRotation.toEulerDegrees(), initialRotation);
            const endPosition = new Vector(xOffset, 0, 0).plus(transform.position);
            const animateTo = new Transform(endPosition, endRotation);
            this.animate(pivot, transform, animateTo);
        }
    }
    toggleDoors(show) {
        const doors = this.coreApi.entities.getByComponent(ComponentIds.DOOR_COMPONENT_ID);
        const shouldHide = show ||
            doors.some(e => e.getComponent(AnimateHingeDoorsComponent.id)?.hideDoors);
        doors.forEach(door => {
            const seeThroughFront = this.coreApi.entities.getDescendantsWithComponent(door, SeeThroughFrontComponent.id);
            if (seeThroughFront[0]) {
                return;
            }
            else {
                const doorFront = HierarchyUtils.findInHierarchy(door, e => e.hasComponent(ComponentIds.DOOR_FRONT_COMPONENT_ID));
                if (doorFront) {
                    this.coreApi.entities.setAllVisible([doorFront], !shouldHide, true);
                }
            }
        });
    }
    getPivot(entity) {
        const children = entity.getComponent(ComponentIds.PARENT_COMPONENT_ID)
            ?.children;
        return children?.find(entity => {
            const productComp = entity.getComponent(ComponentIds.PRODUCT_COMPONENT_ID);
            return productComp?.productRef === 'door_pivot' || productComp?.productRef === 'door-pivot';
        });
    }
    animate(door, from, to) {
        door.addComponent(new AnimationComponent(from, to, 400));
    }
}
//# sourceMappingURL=AnimateHingeDoorsSystem.js.map